module.exports = __webpack_public_path__ + "img/sand-dune-decal-19.c52412e6.png";